/**
 * Select (R398): a native <select>, styled per DESIGN.md §Inputs ("Text input and select
 * (light)": 48px, 10px radius, surface fill, 1px border, 16px text, the chevron drawn in
 * and 44px right padding). Native on purpose: the prototype draws one, Formik's
 * <Field as={Select}> works unchanged, and the browser owns the keyboard and the phone
 * picker. The chevron is a sprite glyph laid over the control (pointer-events off).
 */
import React, { forwardRef } from "react";
import StarsIcon from "../../styles/StarsIcon";
import { cn } from "./cn";

export const Select = forwardRef(function Select(
  { invalid = false, className, wrapperClassName, children, ...props },
  ref,
) {
  return (
    <div className={cn("tw-relative tw-min-w-0", wrapperClassName)}>
      <select
        ref={ref}
        aria-invalid={invalid ? "true" : props["aria-invalid"]}
        className={cn(
          "tw-block tw-w-full tw-min-h-12 tw-appearance-none tw-rounded-md tw-border tw-border-solid tw-border-border tw-bg-surface tw-pl-4 tw-pr-12 tw-text-md tw-text-text",
          "focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-1 focus-visible:tw-outline-focus-ring",
          "disabled:tw-opacity-45 disabled:tw-cursor-not-allowed",
          invalid && "tw-border-danger",
          className,
        )}
        {...props}
      >
        {children}
      </select>
      <StarsIcon
        name="chevronDown"
        className="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-4 tw-my-auto tw-h-4 tw-w-4 tw-text-text-muted"
      />
    </div>
  );
});
